import { isNeitherNullNorUndefined } from './guard.js';
class Defined {
    value;
    constructor(value) {
        this.value = value;
    }
    static parse = (value) => {
        return new this(value);
    };
    isSome = () => {
        return isNeitherNullNorUndefined(this.value);
    };
    map = (fn) => {
        if (this.isSome()) {
            return new Defined(fn(this.value));
        }
        return new Defined(undefined);
    };
    ifDefined = (fn) => {
        if (this.isSome()) {
            fn(this.orThrow('value is null or undefined'));
        }
    };
    orGet = (t) => {
        return isNeitherNullNorUndefined(this.value) ? this.value : t;
    };
    orElse = (fn) => {
        return isNeitherNullNorUndefined(this.value) ? this.value : fn();
    };
    orThrow = (error) => {
        if (isNeitherNullNorUndefined(this.value)) {
            return this.value;
        }
        throw typeof error === 'string' ? new Error(error) : error;
    };
}
export { Defined };
//# sourceMappingURL=defined.js.map